import { motion } from "framer-motion";

const WorkDetail = ({ selectedWork, setSelectedWork }) => {
  if (!selectedWork) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-6xl mx-auto mt-12  sm:px-6 lg:px-8"
    >
      <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
      
        <div className="relative group">
          <img
            src={selectedWork.icon}
            alt={selectedWork.title}
            className="w-full h-[300px] md:h-[450px] object-cover transition-transform duration-500 group-hover:scale-105"
          />

         
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

          {/* Title */}
          <div className="absolute bottom-6 left-6 text-white">
            <h1 className="text-3xl md:text-5xl font-extrabold drop-shadow-lg">
              {selectedWork.title}
            </h1>
          </div>
        </div>

        {/* Content Section */}
        <div className="p-6 md:p-10 space-y-6 bg-gray-50">
          {/* Tag */}
          <span className="inline-block text-primary text-xs md:text-sm px-4 py-1 rounded-full tracking-wide font-semibold shadow-md">
            Project Detail
          </span>

          {/* Description */}
          <p className="text-gray-700 leading-relaxed text-base md:text-lg">
            {selectedWork.desc}
          </p>

          {/* Features / Example - optional */}
          {selectedWork.features && (
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              {selectedWork.features.map((feat, i) => (
                <li key={i}>{feat}</li>
              ))}
            </ul>
          )}

          {/* Back Button */}
          <div className="pt-6">
            <button
              onClick={() => setSelectedWork(null)}
              className="px-8 py-3 rounded-full text-primary font-semibold shadow-lg hover:scale-105 transition-transform duration-300"
            >
              ← Back to Portfolio
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default WorkDetail;
